<template>
  <div class="reports">
    <div v-if="$store.state.pageLoaded" class="reports-listing">
      <div class="filter-wrapper">
        <!--<md-datepicker v-model="period.from" md-immediately>
          <label>Od</label>
        </md-datepicker>
        <md-datepicker v-model="period.to" md-immediately>
          <label>Do</label>
        </md-datepicker>-->
        <Autocomplete v-model="performanceID" :additionalField="'performance_date'" :stateObject="'performancesSimple'" :searchBy="'play_title'" :returnField="'id'" :label="'Odaberi izvedbu'"/>
        <md-button class="md-raised md-dense md-primary" v-on:click="getByDate">
          Traži
        </md-button>
      </div>
      <div v-if="$store.state.receivedData.reportsAboutPlay.list.hasOwnProperty('seat_count')" ref="reports">
        <h2 class="md-title">
          Izvještaj o izvedbi
          <span class="lighter" v-if="searched">
            {{ performance.play_title }} - {{ performance.performance_date }} - {{ performance.performance_time }}
          </span>
        </h2>
        <md-table class="print-table small-table">
          <md-table-row v-for="value, key in seatCount" v-if="key !== 'soldSeat'">
            <md-table-cell>{{ value }}</md-table-cell>
            <md-table-cell>
              <span v-if="key == 'subscription_amount'">{{ formatCurrency($store.state.receivedData.reportsAboutPlay.list.seat_count[key]) }}</span>
              <span v-else>{{ $store.state.receivedData.reportsAboutPlay.list.seat_count[key] }}</span>
            </md-table-cell>
          </md-table-row>
          <md-table-row>
            <md-table-cell><b>Prodanih sjedala</b></md-table-cell>
            <md-table-cell></md-table-cell>
          </md-table-row>
          <md-table-row v-for="value, key in seatCount.soldSeat">
            <md-table-cell>{{ value }}</md-table-cell>
            <md-table-cell>
              {{ $store.state.receivedData.reportsAboutPlay.list.seat_count.sold_seat[key] }}
            </md-table-cell>
          </md-table-row>
          <template v-if="$store.state.receivedData.reportsAboutPlay.list.hasOwnProperty('proscenium')">
            <md-table-row>
              <md-table-cell><b>Proscenij</b></md-table-cell>
              <md-table-cell></md-table-cell>
            </md-table-row>
            <md-table-row v-for="value, key in proscenium">
              <md-table-cell>{{ value }}</md-table-cell>
              <md-table-cell>{{ $store.state.receivedData.reportsAboutPlay.list.proscenium[key] }}</md-table-cell>
            </md-table-row>
          </template>
        </md-table>

        <md-table class="print-table small-table" v-for="value, key in $store.state.receivedData.reportsAboutPlay.list" v-if="['sponsor', 'lease', 'price_labels', 'payment_type', 'seat_category', 'gratis_seat_category'].includes(key)">
          <md-table-row>
            <md-table-head class="t-align-left">{{ tableTitle[key] }}</md-table-head>
            <md-table-head class="t-align-right">Količina</md-table-head>
            <md-table-head class="t-align-right">Iznos</md-table-head>
          </md-table-row>
          <md-table-row v-for="rowValue, rowKey in $store.state.receivedData.reportsAboutPlay.list[key].amount" v-if="rowKey !== 'sum'">
            <md-table-cell class="t-align-left" v-if="['seat_category', 'gratis_seat_category'].includes(key)">
              {{ $store.state.kindsMapper[rowKey] }}
            </md-table-cell>
            <md-table-cell class="t-align-left" v-else-if="key == 'payment_type'">
              {{ payment[rowKey] }}
            </md-table-cell>
            <md-table-cell v-else>{{ rowKey }}</md-table-cell>
            <md-table-cell class="t-align-right">{{ $store.state.receivedData.reportsAboutPlay.list[key].count[rowKey] }}</md-table-cell>
            <md-table-cell class="t-align-right">{{ formatCurrency(rowValue) }}</md-table-cell>
          </md-table-row>
          <md-table-row class="last-row">
            <md-table-cell><strong>Ukupno</strong></md-table-cell>
            <md-table-cell class="t-align-right">{{ $store.state.receivedData.reportsAboutPlay.list[key].count['sum'] }}</md-table-cell>
            <md-table-cell class="t-align-right">{{ formatCurrency($store.state.receivedData.reportsAboutPlay.list[key].amount['sum']) }}</md-table-cell>
          </md-table-row>
        </md-table>

        <md-table class="print-table small-table">
          <md-table-row>
            <md-table-head class="t-align-left">Ukupni prihodi predstave</md-table-head>
            <md-table-head class="t-align-right">Iznos</md-table-head>
          </md-table-row>
          <md-table-row v-for="value, key in $store.state.receivedData.reportsAboutPlay.list.income" v-if="key !== 'sum'">
            <md-table-cell class="t-align-left">{{ income[key] }}</md-table-cell>
            <md-table-cell class="t-align-right">
              {{ formatCurrency(value) }}
            </md-table-cell>
          </md-table-row>
          <md-table-row class="last-row">
            <md-table-cell><strong>Ukupno</strong></md-table-cell>
            <md-table-cell class="t-align-right">{{ formatCurrency($store.state.receivedData.reportsAboutPlay.list.income.sum) }}</md-table-cell>
          </md-table-row>
        </md-table>

        <md-button class="md-primary md-dense md-raised fixed-print-btn print-btn" v-on:click="print($refs.reports)">
          Ispiši
        </md-button>
      </div>
      <div v-else class="error">
        <h3>Nažalost nema izvješća za prikaz</h3>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import ReportsMixin from '../../../mixins/reports-mixin';
import FormatCurrency from '../../../mixins/format-currency';

export default {
  name: 'ReportsPlay',
  mixins: [FormatCurrency, ReportsMixin('getReportsCashRegister')],
  data(){
    return{
      performanceID: '',
      performance: '',
      period:{
        to: new Date(),
        from: new Date(),
      },
      seatCount:{
        'for_sale':'Ukupno u prodaji',
        // 'sum':'Ukupno sjedala',
        // 'reserved': 'Rezervirano',
        'free': 'Slobodno',
        'sold': 'Prodano',
        'gratis': 'Gratis',
        'sponsor': 'Sponzorska sjedala',
        'subscription_count': 'Pretplata',
        'soldSeat': {
          'gratis': 'Na blagajni - gratis',
          // 'lease': 'Zakupljena sjedala',
          'offline': 'Na blagajni - naplatno',
          'online': 'Na webu',
        },
	'scanned': 'Skenirano',
        // 'subscription_amount': 'Učešće pretplatnika',
        // 'used_in_performance': 'Korišteno u predstavi',
      },
      proscenium:{
        'free': 'Slobodno',
        'sold': 'Prodano',
        'total': 'Ukupno'
      },
      tableTitle:{
        'sponsor': 'Sponzori',
        'lease': 'Zakupi',
        'price_labels': 'Tipovi cijena',
        'payment_type': 'Način plaćanja',
        'seat_category': 'Kategorija sjedala',
        'gratis_seat_category': 'Gratisi'
      },
      payment:{
        'cash-offline': 'Gotovina',
        'gratis-offline': 'Gratis',
        'visa-offline': 'Visa',
        'visa-online': 'Visa (web)',
        'american-offline': 'American',
        'american-online': 'American (web)',
        'diners-offline': 'Diners',
        'diners-online': 'Diners (web)',
        'maestro-offline': 'Maestro',
        'maestro-online': 'Maestro (web)',
        'master-offline': 'Master Card',
        'master-online': 'Master Card (web)',
        'discovery-offline': 'Discovery',
        'discovery-online': 'Discovery (web)',
        'v-pay-offline': 'V Pay',
        'v-pay-online': 'V Pay (web)',
        'union-pay-offline': 'UnionPay',
        'union-pay-online': 'UnionPay (web)',
        'virman': 'Virman',
        'coupon': 'Darovni bon',
        'coupon-offline': 'Darovni bon',
        'virman-offline': 'Virman'
      },
      income: {
        'lease': 'Zakupi',
        'sponsor': 'Sponzori',
        'sale': 'Ukupna prodaja',
        'subscription': 'Pretplata učešće',
      }
    }
  },

  computed:{
    ...mapGetters([
      'isPageLoaded'
    ])
  },

  methods:{
    zeroed(data){
      if(parseInt(data) < 10) return `0${data}`
      return data;
    },

    getByDate(){
      let context = {};
      if(this.period.from !== null && this.period.to !== null && this.period.from <= this.period.to){
        this.title = `za razdoblje od ${this.period.from.toLocaleDateString('hr-HR')}
        do ${this.period.to.toLocaleDateString('hr-HR')}`

        context['to'] = this.period.to.toLocaleDateString('hr-HR');
        context['from'] = this.period.from.toLocaleDateString('hr-HR');
      }

      if(this.performanceID !== ''){
        context['performance'] = this.performanceID;
      }

      this.$store.dispatch('getReportsAboutPlay', context);

      this.searched = true;
    },

    getPlayDate(data){
      let date = new Date(data);
      return{
        date: `${this.zeroed(date.getDate())}.${this.zeroed(date.getMonth()+1)}.${this.zeroed(date.getFullYear())}`,
        time: `${this.zeroed(date.getHours())}:${this.zeroed(date.getMinutes())}`,
      }
    }
  },

  watch:{
    isPageLoaded(value){
      if(value) this.performanceID = this.$store.state.receivedData.performancesSimple.list[0].id;
    },

    performanceID(){
      this.performance = this.$store.state.receivedData.performancesSimple.list.filter((performance) =>{return performance.id == this.performanceID})[0];
    }
  }
}
</script>

<style lang="scss" scoped>
  .reports h2{
    text-align: center;
    margin: 50px 0;
    span{
      display: block;
    }

    .lighter{
      margin-top: 15px;
      font-size: 16px;
    }
  }

  .reports-listing{
    padding-bottom: 80px;
    .md-table{
      & + .md-table{
        margin-top: 50px;
      }
    }
  }

  .filter-wrapper{
    display: flex;
    position: relative;
    max-width: 900px;

    .md-field{
      margin-right: 20px;
    }
  }

  .error{
    font-size: 22px;
    margin: 50px 0;
    text-align: center;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
  }

</style>



// WEBPACK FOOTER //
// src/components/Admin/Tickets/ReportsAboutPlay.vue